import { useEffect, useRef, useState } from "react";

import { geoService, type GeoRunDetail } from "../api/geoService";
import { errorText } from "@/shared/lib/apiErrors";

/** 轮询某轮次直到终态(SUCCESS/FAILED);RUNNING 时每 2.5s 拉一次。 */
export function useGeoRunPolling(runId: number | null) {
  const [run, setRun] = useState<GeoRunDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!runId) {
      setRun(null);
      setError(null);
      return;
    }
    let cancelled = false;

    const loop = async () => {
      try {
        const r = await geoService.getRun(runId);
        if (cancelled) return;
        setRun(r);
        setError(null);
        if (r.status === "RUNNING") {
          timerRef.current = setTimeout(() => void loop(), 2500);
        }
      } catch (e: unknown) {
        if (cancelled) return;
        setError(errorText(e));
      }
    };

    void loop();

    return () => {
      cancelled = true;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [runId]);

  return { run, error };
}
